import { WritingFormFields } from '@/components/question/forms/writing/WritingForm';
import { questionGenerator } from '@/data/generators/questionGenerator';
import { Question, QuestionTypeEnum } from '@/models/Question';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterWritingForm(
  writing: WritingFormFields,
): Question {
  return questionGenerator({
    title: normalizeTranslatableField(writing.title),
    context: normalizeTranslatableField(writing.context),
    type: QuestionTypeEnum.WRITING,
  });
}
